import React from 'react';

const Footer = ({ onNavClick }) => {
    const handleNewsletterSubmit = (e) => {
        e.preventDefault();
        const email = e.target.querySelector('input[type="email"]').value;
        if (email) {
            alert('Thank you for subscribing to our newsletter!');
            e.target.querySelector('input[type="email"]').value = '';
        }
    };

    const handleLinkClick = (e, section) => {
        e.preventDefault();
        if (onNavClick) {
            onNavClick(section);
        }
    };

    return (
        <footer className="footer">
            <div className="container">
                <div className="footer-content">
                    <div className="footer-section">
                        <h3>F.A Real Estate</h3>
                        <p>Your trusted partner in finding the perfect property. We're committed to excellence and customer satisfaction.</p>
                        <div style={{ marginTop: '1rem' }}>
                            <p style={{ marginBottom: '0.5rem', fontSize: '0.9rem' }}>
                                <i className="fas fa-map-marker-alt" style={{ marginRight: '8px' }}></i>
                                Opus Tower, Business Bay, Dubai
                            </p>
                            <p style={{ marginBottom: '0.5rem', fontSize: '0.9rem' }}>
                                <i className="fas fa-phone" style={{ marginRight: '8px' }}></i>
                                <a href="tel:+971585110336" style={{ color: 'rgba(255, 255, 255, 0.7)', textDecoration: 'none' }}>+971 58 511 0336</a>
                            </p>
                            <p style={{ marginBottom: '0.5rem', fontSize: '0.9rem' }}>
                                <i className="fas fa-envelope" style={{ marginRight: '8px' }}></i>
                                <a href="mailto:mansoorsuhaib983@yahoo.com" style={{ color: 'rgba(255, 255, 255, 0.7)', textDecoration: 'none' }}>mansoorsuhaib983@yahoo.com</a>
                            </p>
                        </div>
                        <div className="social-links">
                            <a href="#" aria-label="Facebook"><i className="fab fa-facebook"></i></a>
                            <a href="#" aria-label="Twitter"><i className="fab fa-twitter"></i></a>
                            <a href="#" aria-label="Instagram"><i className="fab fa-instagram"></i></a>
                            <a href="#" aria-label="LinkedIn"><i className="fab fa-linkedin"></i></a>
                        </div>
                    </div>
                    <div className="footer-section">
                        <h4>Quick Links</h4>
                        <ul>
                            <li>
                                <a href="#home" onClick={(e) => handleLinkClick(e, 'home')}>Home</a>
                            </li>
                            <li>
                                <a href="#properties" onClick={(e) => handleLinkClick(e, 'properties')}>Properties</a>
                            </li>
                            <li>
                                <a href="#about" onClick={(e) => handleLinkClick(e, 'about')}>About Us</a>
                            </li>
                            <li>
                                <a href="#services" onClick={(e) => handleLinkClick(e, 'services')}>Services</a>
                            </li>
                            <li>
                                <a href="#contact" onClick={(e) => handleLinkClick(e, 'contact')}>Contact</a>
                            </li>
                        </ul>
                    </div>
                    <div className="footer-section">
                        <h4>Services</h4>
                        <ul>
                            <li><a href="#">Property Sales</a></li>
                            <li><a href="#">Property Rentals</a></li>
                            <li><a href="#">Investment Consulting</a></li>
                            <li><a href="#">Property Management</a></li>
                        </ul>
                    </div>
                    <div className="footer-section">
                        <h4>Newsletter</h4>
                        <p>Subscribe to get updates on new properties and offers.</p>
                        <form className="newsletter-form" onSubmit={handleNewsletterSubmit}>
                            <input type="email" placeholder="Your Email" required />
                            <button type="submit">Subscribe</button>
                        </form>
                    </div>
                </div>
                <div className="footer-bottom">
                    <p>&copy; 2024 F.A Real Estate. All rights reserved.</p>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
